import { ConfigurationSchema } from '@jbrowse/core/configuration'

export { default as stateModelFactory } from './model'
export const configSchema = ConfigurationSchema('AddTrackWidget', {})
